import Container from "@components/Atomic/Container/Container";
import React from "react";
import { withUniqueSellingPoint } from "./withUniqueSellingPoint";
import {
  Carousel,
  CarouselProvider,
  CarouselSection,
  CarouselControls,
  CarouselScrollbar,
  Button,
  SanityImage2,
} from "@bared/ui";

const UniqueSellingPoint = withUniqueSellingPoint(({ sections, styles }) => {
  return (
    <Container
      styles={styles}
      data-component-type="section-unique-selling-point"
      width="full"
    >
      <div className="w-full px-micro md:px-[40px] md:pb-mini">
        <CarouselProvider>
          <div className="mb-mini hidden justify-end md:flex">
            <CarouselControls />
          </div>
          <div className="my-zero">
            <Carousel
              ariaLabel="Unique selling points"
              hideNativeScrollbar
              slidesPerView={{
                default: "1",
                md: "2",
                lg: "3",
              }}
              className="space-x-mini"
            >
              {sections?.map((section, index) => (
                <CarouselSection
                  key={section.title}
                  index={index}
                  className="md:pl-0 pl-micro"
                >
                  <Button
                    href={section.link.url}
                    variant="plain"
                    className="pb-0 flex items-start justify-between pt-maxi focus-visible:!outline-offset-[-1px] md:pb-mega md:pb-micro"
                  >
                    <div className="mr-mini min-w-peta max-w-peta">
                      {section?.image?.images?.fallback?.src && (
                        <SanityImage2
                          sizes="100vw"
                          src={section?.image?.images?.fallback?.src}
                        />
                      )}
                    </div>
                    <div className="flex w-full flex-col pb-mini pr-mini text-left">
                      <h5 className="mb-micro text-left font-body text-caption uppercase leading-caption tracking-heading">
                        {section.title}
                      </h5>
                      <div className="pr-mini text-left text-caption leading-caption">
                        {section.content}
                        <div className="text-left underline hover:text-secondary">
                          {section.link.title}
                        </div>
                      </div>
                    </div>
                  </Button>
                </CarouselSection>
              )) || []}
            </Carousel>
            <div className="flex flex-col pb-maxi pt-mini md:hidden">
              <CarouselScrollbar />
            </div>
          </div>
        </CarouselProvider>
      </div>
    </Container>
  );
});

export default UniqueSellingPoint;
